let activeDeviceDid = "";
const listeners = new Set();

const normalizeDeviceDid = (value) => String(value ?? "").trim();

const isDeviceDetailsPage = () => {
  if (typeof window === "undefined") return false;
  return /\/devices\/details\/[^/]+\/?$/i.test(window.location?.pathname || "");
};

const getEffectiveDeviceDid = () => (isDeviceDetailsPage() ? activeDeviceDid : "");

const notify = () => {
  const current = getEffectiveDeviceDid();
  listeners.forEach((listener) => {
    try {
      listener(current);
    } catch (error) {
      console.error("AI device-context listener failed:", error);
    }
  });
};

export const setActiveAiDeviceId = (deviceDid) => {
  const next = normalizeDeviceDid(deviceDid);
  if (activeDeviceDid === next) return;
  activeDeviceDid = next;
  notify();
};

export const clearActiveAiDeviceId = (deviceDid) => {
  const normalized = normalizeDeviceDid(deviceDid);
  if (!normalized || activeDeviceDid === normalized) {
    if (!activeDeviceDid) return;
    activeDeviceDid = "";
    notify();
  }
};

export const getActiveAiDeviceId = () => getEffectiveDeviceDid();

export const subscribeActiveAiDeviceId = (listener) => {
  if (typeof listener !== "function") return () => {};
  listeners.add(listener);

  // Synchronize new subscribers immediately. This avoids a race where Device
  // Details has already published its DID before the global Hey Sama component
  // subscribes, which would otherwise leave the live client on a stale/empty DID.
  try {
    listener(getEffectiveDeviceDid());
  } catch (error) {
    console.error("AI device-context listener failed:", error);
  }

  return () => listeners.delete(listener);
};
